import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';
import { useInfoModal } from './hooks/useInfoModal';
import { getModalContentComponentByType } from './utils/getModalContentByType';
import { selectIsAuthorized } from '../../selectors/calculator';
import { useSelector } from 'react-redux';
import { selectFinancePlatformEnabled } from '../../selectors/calculator/selectFinancePlatformEnabled';

export const ModalContainer: React.FC = () => {
  const isAuthorized = useSelector(selectIsAuthorized);
  const financePlatformEnabled = useSelector(selectFinancePlatformEnabled);
  const { isModalOpen, handleCloseModal, handleOpenAuthModal, modalContent, modelType } = useInfoModal();

  const ContentComponent = React.useMemo(
    () =>
      getModalContentComponentByType({
        type: modelType,
        content: modalContent,
        isAuthorized: financePlatformEnabled || isAuthorized,
        handleOpenAuthModal,
      }),
    [modelType, modalContent, isAuthorized, handleOpenAuthModal, financePlatformEnabled],
  );

  return (
    <ModalWindow open={isModalOpen} content={ContentComponent} onClose={handleCloseModal} fixed width={600} size="XS" />
  );
};

ModalContainer.displayName = 'ModalContainer';
